let lastGlobalRequestErrorAt = 0;

/** 记录最近一次请求层错误，让页面兜底提示避免再次弹出重复的错误 Toast。 */
export const markGlobalRequestError = () => {
    lastGlobalRequestErrorAt = Date.now();
};

/** 判断页面错误是否紧随请求层错误产生，时间窗口覆盖同一请求事件的 React 更新周期。 */
export const hasRecentGlobalRequestError = (windowMs = 1500) =>
    lastGlobalRequestErrorAt > 0 && Date.now() - lastGlobalRequestErrorAt <= windowMs;
